import { createSelector } from '@ngrx/store';
import { getWizzardSimpleItem } from '../getWizzardSimpleItem';

export const isWizzardIngredientSelected = (ingredientPLU: number) =>
    createSelector(getWizzardSimpleItem, (simpleItem) => simpleItem?.IngredientsChanges?._SelectedIngredientPLUs?.some((plu) => plu === ingredientPLU) ?? false);
